import api from '@/api/axiosApi'

type DownloadTemplateOptions = (
  | { includeExisting?: false }
  | { includeExisting: true; planId: string; versionId: string }
) & { signal?: AbortSignal }

export async function downloadTemplate(
  options: DownloadTemplateOptions = {}
): Promise<void> {
  const response = await api.get('/product-lists/template', {
    params: {
      type: 'sourcing',
      ...(options.includeExisting && {
        include_existing: true,
        plan_id: options.planId,
        version_id: options.versionId,
      }),
    },
    responseType: 'blob',
    signal: options.signal,
  })

  // Closing the dialog must not trigger a late download.
  if (options.signal?.aborted) return

  // Create blob URL and trigger download
  const blob = new Blob([response.data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  })
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = options.includeExisting
    ? 'sourcing_update_template.xlsx'
    : 'sourcing_import_template.xlsx'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.URL.revokeObjectURL(url)
}
